/* projects/speaker-platform/src/app/atoms/user-picture/user-picture.component.scss */
.userpicture {
  position: relative;
}
.userpicture--collapsed {
  transform: translateY(-103px) translateX(95px) scale(0.7);
}
.userpicture {
  width: 110px;
  height: 110px;
  transition: all 0.3s;
}
.userpicture__status {
  position: absolute;
  top: 5px;
  right: 9px;
}
.userpicture--large {
  width: 145px;
  height: 145px;
}
.userpicture--small {
  width: 44px;
  height: 44px;
}
.userpicture--small .userpicture__status {
  top: 0;
  right: 0;
}
.userpicture__picture,
.userpicture__nopicture {
  border-radius: 50%;
  width: 100%;
  height: 100%;
}
.userpicture__nopicture {
  background-color: #FFED00;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=user-picture.component-WUNOPRV2.css.map */
